<template>
  <v-container class="helmi-group-dashboard pt-4">
    <helmi-group-dashboard-card
      :initializing="loadingOffices"
      class="helmi-group-dashboard-offices mb-4"
      title="Valitse asuntomyymälät"
    >
      <div class="px-4">
        <v-chip-group
          v-model="selectedOfficeIndexes"
          active-class="primary white--text"
          class="mb-4"
          column
          multiple
        >
          <v-chip
            v-for="office in offices"
            :key="office.company_id"
            small
          >
            {{ office.name }}
          </v-chip>
        </v-chip-group>

        <v-btn
          rounded
          x-small
          outlined
          color="primary"
          class="mb-4"
          @click="toggleAll()"
        >
          {{ selectedOffices.length !== offices.length ? 'Valitse kaikki' : 'Poista valinnat' }}
        </v-btn>
      </div>
    </helmi-group-dashboard-card>

    <helmi-group-dashboard-card
      class="helmi-group-dashboard-listings"
      title="Kohteet"
      :initializing="loading"
    >
      <div class="px-4">
        <v-chip-group
          v-model="selectedPropertyTypes"
          active-class="primary white--text"
          class="mb-4"
          column
          multiple
        >
          <v-chip
            v-for="propertyType in propertyTypes"
            :key="propertyType.value"
            small
          >
            {{ propertyType.text }}
          </v-chip>
        </v-chip-group>
      </div>
      <v-row class="mx-0">
        <v-col
          cols="12"
          md="9"
          class="px-4 pb-0"
        >
          <v-text-field
            v-model="query"
            dense
            hint="Syötä vähintään 3 merkkiä"
            label="Hae osoitteella, kaupunginosalla tai kaupungilla"
            outlined
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="pt-0"
        >
          <v-radio-group
            v-model="status"
            row
            dense
          >
            <v-radio
              label="Aktiiviset"
              :value="0"
            />
            <v-radio
              label="Kaikki"
              :value="1"
            />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-list two-line>
        <v-list-item
          v-for="(item, index) in properties"
          :key="item.id"
          :style="`animation-delay: ${item.idx * 50}ms;`"
          class="p-relative"
          @click="openMenu(item)"
        >
          <span
            :class="colors[index % colors.length]"
            class="list-ornament"
          />
          <v-list-item-avatar
            class="mr-4 my-1"
            size="80"
          >
            <v-icon
              v-if="item.image.endsWith('/')"
              size="64"
              color="grey lighten-2"
            >
              home
            </v-icon>
            <v-img
              v-else
              :src="item.image"
              @error="item.image = item.image.replace('/thumbs', '')"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    color="primary"
                    width="2"
                    indeterminate
                  />
                </v-row>
              </template>
            </v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="d-flex align-center">
              <span class="font-weight-medium">
                {{ item.address }} {{ item.apartmentNumber }}
                <v-icon
                  v-if="item.slide > 0"
                  color="pink"
                  small
                  class="ml-2"
                >tv</v-icon>
              </span>
            </v-list-item-title>
            <v-list-item-subtitle class="d-flex align-center">
              <v-icon
                class="mr-1"
                color="pink"
                small
              >
                place
              </v-icon>
              <span class="font-weight-medium black--text">
                {{ item.zip }} {{ item.city }} |
                {{ item.district }}
              </span>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ item.type }}, {{ item.rooms }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Välittäjä: {{ agentName(item) }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Toimeksiantaja: {{ item.customer.name }} {{ item.customer.phone }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-list-item-action-text>
              <div class="statustext">
                <v-chip x-small outlined>
                  #{{ item.orderNumber }}
                </v-chip>

                <v-chip
                  x-small
                  outlined
                >
                  {{ item.statusText }}
                </v-chip>

                <v-chip v-if="item.isRental < 2" x-small>
                  {{ (item.unencumberedPrice > 0 ? item.unencumberedPrice : item.price)
                    | currency({ digits: 0 }) }}
                </v-chip>

                <v-chip v-else x-small>
                  {{ item.rentPerMonth | currency({ digits: 0 }) }} / kk
                </v-chip>
              </div>
            </v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <div id="end"/>
    </helmi-group-dashboard-card>
    <v-dialog v-model="itemModal" max-width="400">
      <v-card>
        <v-card-title>
          {{ currentItem.address }} {{ currentItem.apartmentNumber }}
        </v-card-title>
        <v-list
          v-if="!slidesEdit"
          nav
          dense
        >
          <v-list-item-group
            color="primary"
          >
            <v-list-item @click="slideEdit(currentItem)">
              <v-list-item-icon>
                <v-icon>tv</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ currentItem.slide > 0 ? 'Poista ikkunaesityksestä'
                    : 'Aseta ikkunaesitykseen' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :href="currentItem.webpage" target="_blank">
              <v-list-item-icon>
                <v-icon>web</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Kohde kotisivulla
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-card-text v-if="slidesEdit">
          <v-select
            v-model="selectedAgent"
            :items="agents"
            label="Yhteyshenkilö"
            return-value
            outlined
            dense
            hide-details
          />
        </v-card-text>

        <v-card-actions v-if="slidesEdit">
          <v-spacer/>
          <v-btn
            text
            @click="slidesEdit = false;"
          >
            Peruuta
          </v-btn>
          <v-btn
            text
            @click="setToSlideShow(currentItem.id)"
          >
            Aseta
          </v-btn>
        </v-card-actions>

        <v-card-actions v-if="!slidesEdit">
          <v-spacer/>
          <v-btn
            text
            @click="itemModal = false;"
          >
            Sulje
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { apiGet } from '../../api';

export default {

  components: {
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  data: () => ({
    colors: [
      'primary lighten-2',
      'purple lighten-2',
      'pink lighten-2',
      'light-blue lighten-2',
      'teal lighten-2',
    ],
    slidesEdit: false,
    currentItem: {},
    itemModal: false,
    properties: [],
    loadingOffices: false,
    selectedOffices: [],
    selectedOfficeIndexes: [],
    selectedPropertyTypes: [],
    offices: [],
    query: '',
    loading: false,
    pagination: 0,
    status: 0,
    noMoreProperties: false,
    agents: [],
    selectedAgent: null,
    propertyTypes: [
      {
        value: 0,
        text: 'Omakotitalo',
      },
      {
        value: 1,
        text: 'Rivitalo',
      },
      {
        value: 2,
        text: 'Kerrostalo',
      },
      {
        value: 3,
        text: 'Loma-asunto',
      },
      {
        value: 4,
        text: 'Tontti',
      },
      {
        value: 5,
        text: 'Liiketila',
      },
      {
        value: 6,
        text: 'Autotalli',
      },
      {
        value: 7,
        text: 'Varasto',
      },
      {
        value: 8,
        text: 'Paritalo',
      },
      {
        value: 9,
        text: 'Erillistalo',
      },
      {
        value: 10,
        text: 'Lomahuoneisto',
      },
      {
        value: 11,
        text: 'Loma-asunto ulkomailla',
      },
      {
        value: 12,
        text: 'Loma-osake',
      },
      {
        value: 13,
        text: 'Omakotitalotontti',
      },
      {
        value: 14,
        text: 'Vapaa-ajan tontti',
      },
      {
        value: 15,
        text: 'Rivitalotontti',
      },
      {
        value: 16,
        text: 'Autopaikka',
      },
      {
        value: 17,
        text: 'Maatila',
      },
      {
        value: 18,
        text: 'Metsätila',
      },
      {
        value: 19,
        text: 'Toimistotila',
      },
      {
        value: 20,
        text: 'Tuotantotila',
      },
      {
        value: 21,
        text: 'Puutalo-osake',
      },
      {
        value: 22,
        text: 'Luhtitalo',
      },
      {
        value: 23,
        text: 'Muu toimitila',
      },
      {
        value: 24,
        text: 'Muu',
      },
    ],
  }),

  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
  },

  watch: {
    query(val) {
      if (val && val.length > 2) {
        this.getPropertiesDebounced();
      } else if (!val) {
        this.getPropertiesDebounced();
      }
    },

    selectedOfficeIndexes: {
      async handler(value) {
        this.selectedOffices = value.map(office => this.offices[office]);
        await this.getProperties();
      },
      deep: true,
      immediate: true,
    },

    selectedPropertyTypes: {
      async handler() {
        await this.getProperties();
      },
      deep: true,
      immediate: true,
    },

    status: {
      async handler() {
        await this.getProperties();
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    await this.getOffices();
    await this.getProperties();
    await this.getGroupAgents();
    this.observe();
  },

  methods: {
    async slideEdit(currentItem) {
      if (currentItem.slide > 0) {
        await apiGet(`properties/slide-show/remove/${currentItem.id}`);
        // make request
        this.currentItem.slide = 0;
        this.slidesEdit = false;
        this.itemModal = false;
        return;
      }

      this.selectedAgent = this.agents.find(agent => agent.id === currentItem.agentId)?.value
  || this.userDetails.id;

      this.slidesEdit = true;
    },
    async setToSlideShow(id) {
      if (!this.selectedAgent) {
        await apiGet(`properties/slide-show/set/${id}`);
      } else {
        await apiGet(`properties/slide-show/set/${id}/${this.selectedAgent}`);
      }
      this.currentItem.slide = 1;
      this.slidesEdit = false;
      this.itemModal = false;
    },
    openMenu(property) {
      this.currentItem = property;
      this.itemModal = true;
      console.log(property);
    },
    observe() {
      const observer = new IntersectionObserver(((entries) => {
        if (entries[0].isIntersecting === true && !this.noMoreProperties) {
          this.paginate();
        }
      }), { threshold: [0] });

      observer.observe(document.querySelector('#end'));
    },
    async getGroupAgents() {
      const response = await apiGet('reporting/group-agents');
      console.log(response);
      this.agents = response.result.map(item => ({
        value: item.id,
        text: item.name,
      }));

      this.agents.push({ value: null, text: 'Kohteen hoitaja' });
    },
    async getOffices() {
      this.loadingOffices = true;
      const response = await apiGet('reporting/group-companies');
      this.offices = response.result.map((item) => {
        let { name } = item;

        if (response.result.filter(i => i.name === name).length > 1) {
          name = `${item.name} (${item.company_id})`;
        }

        return {
          company_id: item.company_id,
          name,
          phone: item.phone,
          address: item.address,
          city: item.city,
          email: item.email,
        };
      });
      this.selectedOffices = [...this.offices];
      this.selectedOfficeIndexes = this.offices.map((item, index) => index);
      this.loadingOffices = false;
    },

    toggleAll() {
      if (this.offices.length !== this.selectedOffices.length) {
        this.selectedOfficeIndexes = this.offices.map((item, index) => index);
      } else {
        this.selectedOfficeIndexes = [];
      }
    },

    agentName(property) {
      if (property.agentName) {
        return `${property.agentName}, ${property.agentPhone} | ${property.companyName}`;
      }

      return property.companyName;
    },

    getPropertiesDebounced() {
      this.loading = true;
      // cancel pending call
      clearTimeout(this._timerId);
      const that = this;
      // delay new call 500ms
      this._timerId = setTimeout(async () => {
        await this.getProperties();
        that.loading = false;
      }, 500);
    },
    async fetchProperties() {
      this.loading = true;
      const propertyTypes = this.selectedPropertyTypes.length
        ? this.selectedPropertyTypes : this.propertyTypes.map(item => item.value);
      let response = (await apiGet(`group/properties/${this.selectedOffices.map(office => office.company_id).join(',')}/${propertyTypes.join(',')}/${this.pagination}/${this.status}/${this.query}`)).properties;
      response = response.map((item, index) => ({ ...item, idx: index }));

      this.loading = false;
      return response;
    },
    async getProperties() {
      if (!this.selectedOfficeIndexes.length) {
        this.properties = [];
        return;
      }
      this.pagination = 0;
      this.noMoreProperties = false;
      this.properties = await this.fetchProperties();
    },

    async paginate() {
      if (!this.selectedOfficeIndexes.length) {
        this.properties = [];
        return;
      }
      this.pagination += 1;
      const addProperties = await this.fetchProperties();
      this.properties = [...this.properties, ...addProperties];
      if (!addProperties.length) {
        this.noMoreProperties = true;
      }
    },
  },
};
</script>

<style lang="scss">
  .helmi-group-dashboard-listings {
    height: 100%;

    &.dark {
      background: #2c2945;
    }

    .v-list-item {
      animation-duration: 800ms;
      animation-fill-mode: both;
      animation-iteration-count: 1;
      animation-name: fadeIn;
      animation-timing-function: cubic-bezier(0.0, 0.0, 0.2, 1);

      .list-ornament {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 4px;
      }
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
        transform: translateX(-16px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .h-list__group {
      overflow: hidden;
    }

    .statustext {
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-end;
    }
  }

  .v-label {
    font-size: 12px;
  }
  </style>

